.bell-button {
  all: unset;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: #{$bp-medium - 1}) {
    padding: 0.8rem;
  }

  svg {
    color: var(--color-grayscale-manatee);
    width: 1.6em;
    height: 1.6rem;
    pointer-events: none;
  }

  &:not([data-count='0']) {
    &:after {
      width: 1.6rem;
      height: 1.6rem;
      content: attr(data-count);
      position: absolute;
      top: 0.6rem;
      right: 0.5rem;
      background: var(--color-primary-telemagenta, #d53075);
      border-radius: 50%;
      color: var(--color-grayscale-white, #fafafa);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 1rem;
      font-weight: 700;

      @media screen and (min-width: $bp-medium) {
        top: -0.2rem;
        right: -0.3rem;
      }
    }
  }

  @media screen and (min-width: $bp-medium) {
    min-width: 2.4rem;

    svg {
      width: 2rem;
      height: 2rem;
    }
  }
}

.notification-drawer {
  @media screen and (min-width: $bp-medium) {
    width: 48rem;
  }
}

.mark-read-button {
  all: unset;
  color: var(--color-primary-crayola, #367bff);
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.4rem;
  cursor: pointer;
}

.actions {
  display: flex;
  flex-direction: row;
  gap: 1.6rem;

  @media screen and (max-width: #{$bp-medium - 1}) {
    & > .mark-read-button {
      display: none;
    }
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem 2.4rem 2.4rem;
  overflow-y: auto;
  height: 100%;

  & > .mark-read-button {
    display: none;
  }

  @media screen and (max-width: #{$bp-medium - 1}) {
    padding: 1.6rem;

    & > .mark-read-button {
      display: block;
      width: fit-content;
      align-self: end;
      margin-bottom: 0.8rem;
    }
  }
}

.close-button {
  all: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 0.4rem;
  color: var(--color-grayscale-shuttle);
  box-sizing: border-box;
  border: 0.15rem solid transparent;
  cursor: pointer;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}
